import { useState } from "react";
import { useCategories, useSubCategories } from "../../hooks/shop/useCategory";

export const useNavbarShopViewModel = () => {
    const [hoveredCategory, setHoveredCategory] = useState(null);
    const { data: categories = [], isLoading: categoriesLoading } = useCategories();
    const { data: subcategories = [], isLoading: subsLoading } = useSubCategories(hoveredCategory ? hoveredCategory.ID : null);

    return {
        categories,
        categoriesLoading,
        hoveredCategory,
        setHoveredCategory,
        subcategories,
        subsLoading
    };
};
